import _ from 'lodash';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { NoRecordsFoundMessage, PleaseWaitMessage, getHandlerTableChange } from './TablePaginationHelpers';
import { Pagination } from '../pagination/Pagination';

const defaultClasses = 'table-head-custom table-vertical-center overflow-hidden';
const defaultWrapperClasses = 'table-responsive';
const defaultKeyField = 'id';
const defaultSorted = [{ dataField: 'id', order: 'desc' }];
const defaultPaginationOptions = {
    custom: true,
    totalSize: 0,
    sizePerPageList: [{ text: '10', value: 10 }, { text: '25', value: 25 }, { text: '50', value: 50 }],
    sizePerPage: 10,
    page: 1
};

export function Table ({
    data = [],
    columns = [],
    pagination = {},
    classes = defaultClasses,
    wrapperClasses = defaultWrapperClasses,
    sort = defaultSorted,
    keyField = defaultKeyField,
    isLoading = true,
    onChange = _.noop
}) {
    data = data || [];
    pagination = _.defaultsDeep({}, pagination, defaultPaginationOptions);
    pagination.totalSize = data.length || 0;

    return (
        <PaginationProvider pagination={paginationFactory(pagination)}>
            {({ paginationProps, paginationTableProps }) => {
                return (
                    <Pagination
                        isLoading={isLoading}
                        paginationProps={paginationProps}
                    >
                        <BootstrapTable
                            hover
                            remote
                            striped
                            bootstrap4
                            data={data}
                            columns={columns}
                            bordered={false}
                            keyField={keyField}
                            classes={classes}
                            wrapperClasses={wrapperClasses}
                            defaultSorted={sort}
                            onTableChange={getHandlerTableChange(onChange)}
                            {...paginationTableProps}
                        />

                        <PleaseWaitMessage entities={data} />
                        <NoRecordsFoundMessage entities={data} />
                    </Pagination>
                );
            }}
        </PaginationProvider>
    );
}
